<template>
  <div class="form-steps-vue">
    <input type="hidden" name="id" :value="data && data.id"/>
    <div class="steps">
      <div class="tabs">
        <h3 class="tab tab-0">Dados pessoais</h3>
        <h3 class="tab tab-1">Endereço</h3>
        <h3 class="tab tab-2">Propriedade(s)</h3>
      </div>
      <div class="content">
        <p class="text-edit" v-if="data && data.id">
          <b>Alterar pré-cadastro</b>
          <br/>o status do seu pré-cadastro é
          <b>{{ data.status }}</b>, e as observações são:
          <i>{{ data.motivo }}</i>
        </p>
        <div class="container content-0">
          <p class="text-description">
            O primeiro passo é a coleta de algumas informações básicas sobre você! Após preencher as informações obrigatórias
            <span
              class="text text-red"
            >(*)</span>, clique em
            <span class="text-next" @click="changeStep($event, +1)">Próximo</span>.
          </p>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group required">
                <label for="cpf_cnpj">CPF/CNPJ</label>
                <input
                  type="text"
                  class="form-control loading"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  name="cpf_cnpj"
                  id="cpf_cnpj"
                  v-model="model.cpf_cnpj"
                  @blur="onCpfCnpjBlur"
                  :readonly="data && data.id"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label for="name">Nome/Razão social</label>
                <input type="text" class="form-control" name="name" id="name" v-model="model.nome"/>
              </div>
            </div>
            <div class="col-md-6">
              <div :class="{ 'form-group': true, required: isCpf }">
                <label for="name">Apelido</label>
                <input
                  type="text"
                  class="form-control"
                  name="apelido"
                  id="apelido"
                  v-model="model.apelido"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label for="email">E-mail</label>
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  v-model="model.email"
                  id="email"
                  @blur="onEmailBlur"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label for="sexo">Sexo</label>
                <select class="form-control" name="sexo" id="sexo" v-model="model.sexo">
                  <option value>Selecione</option>
                  <option value="M">Masculino</option>
                  <option value="F">Feminino</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="fixo">Telefone fixo</label>
                <input
                  type="tel"
                  class="form-control"
                  name="fixo"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  id="fixo"
                  v-model="model.fixo"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label for="celular">Celular</label>
                <input
                  type="text"
                  class="form-control"
                  name="celular"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  id="celular"
                  v-model="model.celular"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div :class="{'form-group': true, required: !isEditing}">
                <label
                  for="documento"
                >Documento de identificação com foto (ex: Identidade, CNH, etc)</label>
                <template v-if="isEditing && model.docIdentificacao.cod_anexo">
                  <a
                    :href="this.getFile(model.docIdentificacao.cod_anexo)"
                    target="_blank"
                  >Visualizar arquivo</a>
                  <small>Caso deseje alterar, escolha um novo arquivo:</small>
                </template>
                <input
                  type="file"
                  class="form-control"
                  name="documento"
                  id="documento"
                  accept="application/pdf, image/*"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="container content-1">
          <p class="text-description">
            O segundo passo é a coleta de algumas informações sobre seu endereço.
            Insira informações do seu endereço de contato, preferencialmente na zona Urbana.
            <br/>Não se esqueça de enviar um comprovante de endereço.
            <br/>Após preencher as informações obrigatórias
            <span class="text text-red">(*)</span>, clique em
            <span class="text-next" @click="changeStep($event, +1)">Próximo</span>.
          </p>
          <div class="row">
            <div class="col-md-2">
              <div class="form-group required">
                <label for="cep">CEP</label>
                <input
                  type="tel"
                  class="form-control"
                  name="cep"
                  v-mask="['##.###-###']"
                  v-model="model.cep"
                  @change="onChangeCep"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group required">
                <label for="logradouro">Logradouro</label>
                <input
                  type="text"
                  class="form-control"
                  name="logradouro"
                  id="logradouro"
                  required
                  v-model="model.logradouro"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group required">
                <label for="numero_endereco">Número</label>
                <input
                  type="text"
                  class="form-control numbers-only"
                  name="numero_endereco"
                  id="numero_endereco"
                  v-model="model.numero"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group required">
                <label for="bairro">Bairro</label>
                <input
                  type="text"
                  class="form-control"
                  name="bairro"
                  id="bairro"
                  v-model="model.bairro"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group required">
                <label for="distrito">Distrito</label>
                <input
                  type="text"
                  class="form-control"
                  name="distrito"
                  id="distrito"
                  v-model="model.distrito"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="complemento">Complemento</label>
                <input
                  type="text"
                  class="form-control"
                  name="complemento"
                  id="complemento"
                  v-model="model.complemento"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group required">
                <label for="municipio">Município</label>
                <input
                  type="text"
                  class="form-control"
                  name="municipio"
                  id="municipio"
                  v-model="model.municipio"
                />
                <input
                  type="hidden"
                  name="cod_municipio"
                  id="cod-municipio"
                  v-model="model.cod_municipio"
                />
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group required">
                <label for="estado">UF</label>
                <input
                  type="text"
                  class="form-control"
                  name="estado"
                  id="estado"
                  v-model="model.estado"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div :class="{'form-group': true, required: !isEditing}">
                <label for="comp_endereco">Comprovante de endereço (anexo)</label>
                <template v-if="isEditing && model.docComprEndereco.cod_anexo">
                  <a
                    :href="this.getFile(model.docComprEndereco.cod_anexo)"
                    target="_blank"
                  >Visualizar arquivo</a>
                  <small>Caso deseje alterar, escolha um novo arquivo:</small>
                </template>
                <input
                  type="file"
                  class="form-control"
                  name="comp_endereco"
                  id="comp_endereco"
                  accept="application/pdf, image/*"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="container content-2">
          <p class="text-description">
            O terceiro passo é a coleta de informações sobre sua(s) propriedade(s).
            <br/>Para adicionar uma exploração (seja Animal ou Vegetal), clique em "
            <b>Adicionar exploração</b>".
            <br/>Para adicionar uma nova propriedade, clique em
            "
            <b>Adicionar propriedade</b>"
            <br/>Após preencher as informações obrigatórias
            <span class="text text-red">(*)</span>, clique em
            <b>Salvar</b>.
          </p>
          <pre-cadastro-produtor-propriedades :data="model.properties"></pre-cadastro-produtor-propriedades>

          <div class="row bottom-checks">
            <div class="col-md-5">
              <div class="form-check required">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="informacoes_veridicas"
                  value="1"
                  id="informacoesVeridicasCheck"
                />
                <label
                  class="form-check-label"
                  for="informacoesVeridicasCheck"
                >Declaro que as informações aqui prestadas são verídicas</label>
              </div>
              <div class="form-check mt-1">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="solicito_pre-cadastro"
                  value="1"
                  id="solicitoPreCadastroCheck"
                  :checked="data && data.solicita_pre_cadastro"
                />
                <label
                  class="form-check-label"
                  for="solicitoPreCadastroCheck"
                >Solicito que seja realizado o cadastro no portal do produtor para ter acesso aos serviços da ADAGRI, tais como, (GTA, ficha sanitária, declaração de vacinação contra Febre Aftosa, etc).</label>
              </div>
            </div>
          </div>
          <div class="row">
            <hr/>
            <div class="col-md-12" style="align-items: center;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;">
              <div class="h-captcha" data-sitekey="1c13d2e6-c37a-4f6e-8731-57fab2e94178"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="actions">
        <a
          href="#"
          @click="changeStep($event, -1)"
          :class="{ 'steps-control': true, disabled: !allowPrev }"
        >Anterior</a>
        <a
          href="#"
          @click="changeStep($event, +1)"
          :class="{ 'steps-control': true }"
        >{{ nextText }}</a>
      </div>
    </div>

    <div class="page-overlay" v-if="loadingSubmitForm">
      <div class="spinner"></div>
    </div>
    <modal-component
      :title="feedback.cod == 0 ? 'Sucesso' : 'Erro'"
      :error="feedback.cod !== 0"
      :value="showFeedbackModal"
      :preventClose="feedback.cod == 0"
      @input="onCloseFeedbackModal"
    >
      <div class="modal-content">
        <p>{{ feedback.txt }}</p>
        <a :href="feedback.link_boleto" class="btn-primary" v-if="feedback.link_boleto">
          <span>Baixar o boleto</span>
        </a>
        <a href="https://www.adagri.ce.gov.br/" class="btn-primary" v-else-if="feedback.cod == 0">
          <span>Fechar</span>
        </a>
      </div>
    </modal-component>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: false,
    },
  },
  data: () => ({
    activeTab: 0,
    nextText: "Próximo",
    showFeedbackModal: false,
    loadingSubmitForm: false,
    feedback: {},
    isCpf: true,
    isEditing: false,
    model: {
      cpf_cnpj: "",
      nome: "",
      apelido: "",
    email: "",
      sexo: "",
      fixo: "",
      celular: "",
      cep: "",
      logradouro: "",
      numero: "",
      bairro: "",
      distrito: "",
      complemento: "",
      municipio: "",
      cod_municipio: "",
      estado: "",
      properties: [],
    },
  }),
  computed: {
    allowPrev() {
      return this.activeTab > 0;
    },
  },
  methods: {

    getFile(codAnexo) {
      return "/public/download-file/cod-anexo/" + btoa(codAnexo);
    },

    changeActive() {
      document.querySelectorAll(`.tabs .tab`).forEach((node) => {
        node.classList.remove("active");
      });
      document.querySelectorAll(`.content .container`).forEach((node) => {
        node.classList.remove("active");
      });
      document
        .querySelector(`.tabs .tab.tab-${this.activeTab}`)
        .classList.add("active");
      document
        .querySelector(`.content .container.content-${this.activeTab}`)
        .classList.add("active");

      const stepsDiv = this.$el.querySelector(".steps");
      stepsDiv.scrollIntoView();
    },
    changeStep(ev, op) {
      ev.preventDefault();
      ev.stopPropagation();
      const tabsCount = this.$el.querySelectorAll(".tabs .tab").length;
      if (op < 0 && this.activeTab == 0) return;
      else if (op < 0) {
        this.activeTab += op;
        this.changeActive();
        this.nextText = "Próximo";
        return;
      }

      let hasError = false;
      let focusSeted = false;
      const activeTab = this.$el.querySelector(".container.active");
      activeTab.querySelectorAll(".form-group.required").forEach((node) => {
          const formControl = node.querySelector(".form-control");
          if (!formControl.value) {
            node.classList.add("error");
            hasError = true;

            if (!focusSeted) {
              formControl.focus();
              focusSeted = true;
            }
          } else {
            node.classList.remove("error");
          }
        });

      // Check if required checkbox are checked
      this.$el
        .querySelector(".container.active")
        .querySelectorAll(".form-check.required")
        .forEach((node) => {
          const checkInput = node.querySelector(".form-check-input");
          if (!checkInput.checked) {
            node.classList.add("error");
            hasError = true;

            if (!focusSeted) {
              checkInput.focus();
              focusSeted = true;
            }
          } else {
            node.classList.remove("error");
          }
        });

      if (!hasError && op > 0 && this.activeTab == tabsCount - 1) {
        // Salvando
        this.onSave();
      } else if (!hasError) {
        this.activeTab += op;
        this.changeActive();
        if (this.activeTab === tabsCount - 1) {
          this.nextText = "Salvar";
        } else {
          this.nextText = "Próximo";
        }
      }
    },

    validarCapctha() {
      //VERIFICA SE O HCATPCHA FOI SELECIONADO
      if (hcaptcha.getResponse() != "") return true;

      //IMPEDE O ENVIO DO FORMULÁRIO
      alert('Selecione a caixa de "Sou humano"');
      return false;
    },

    onSave() {
      const form = document.getElementById("pre-cadastro-produtor-form");
      const formData = new FormData(form);
      this.loadingSubmitForm = true;

      if(this.validarCapctha()){
        axios
          .post("/produtor/pre-cadastro/salvar", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => response.data)
          .then((response) => {
            if (response.msg) {
              this.feedback = response.msg;

              this.showFeedbackModal = true;
            } else {
              throw "Resposta do servidor no formato inválido";
            }
          })
          .catch((error) => {
            console.log(error);
            this.feedback = {
              cod: 1,
              txt:
                "Não foi possível se conectar com o servidor. Tente novamente mais tarde.",
            };
            this.showFeedbackModal = true;
          })
          .then(() => {
            this.loadingSubmitForm = false;
          });
      } else {
        this.loadingSubmitForm = false;
      }
    },
    onEmailBlur() {
      if (
        this.model.email !== "" &&
        !window.emailValidation(this.model.email)
      ) {
        this.model.email = "";
        alert("E-mail inváliddo");
      }
    },
    onCpfCnpjBlur() {
      const cpfCnpj = this.model.cpf_cnpj.replace(/\D/g, "");
      let consult = "";

      document.activeElement.blur();

      if (cpfCnpj.length === 11) {
        consult = "cpf";
        this.isCpf = true;
        if (!window.cpfValidation(cpfCnpj)) {
        alert("CPF inváliddo");
          this.cpfCnpj = "";
          return;
        }
      } else if (cpfCnpj.length === 14) {
        consult = "cnpj";
        this.isCpf = false;
        if (!window.cnpjValidation(cpfCnpj)) {
          alert("CNPJ inváliddo");
          this.model.cpf_cnpj = "";
          return;
        }
      } else if (cpfCnpj === "") {
        return;
      } else {
        alert("CPF/CNPJ inválido");
        this.model.cpf_cnpj = "";
        return;
      }

        const scope = this;
        $.ajax({
        url: "/solicitacao-acesso-produtor/consulta-" + consult,
          data: {
          [consult]: scope.model.cpf_cnpj.replace(/\D/g, ""),
          },
          dataType: "json",
          type: "GET",
        success: (json) => {
            if (json.msg && json.msg.cod === 0) {
              if (json.msg.data == 1) {
              scope.model.cpf_cnpj = "";
                alert("Produtor já cadastrado.");
              }
            }
        },
        });
    },
    onCloseFeedbackModal(ev) {
      this.showFeedbackModal = false;
    },
    onChangeCep() {
      window.loadAddressByCep(this.model.cep, (data) => {
        this.model.cep = data.cep;
        this.model.logradouro = data.logradouro;
        this.model.bairro = data.bairro;
        this.model.municipio = data.localidade;
        this.model.estado = data.uf;
        this.model.cod_municipio = data.ibge;

        data.error && this.$toast.error("CEP inválido");
      });
    },
  },
  mounted() {

    //console.log(">>> " + Base64.encode("WTqeytqeu"));

    this.changeActive();



    if (this.data) {
      console.log("Aqui ...")
      console.log(this.data)

      this.isEditing = true;
      this.model = this.data;

      this.model.docIdentificacao = this.data.images.find(
        (item) => item.chave === "pre_doc_foto"
      );
      this.model.docComprEndereco = this.data.images.find(
        (item) => item.chave === "pre_comprovante_endereco"
      );
  }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .sida-modal {
  max-width: 500px;
  .modal-content {
    height: auto;
  }
}
</style>
